export const TIME_INPUT_DEBOUNCE = 500